import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = 'https://qlhqgfpbrloaygqwyfcu.supabase.co';
const SUPABASE_ANON_KEY = 'sb_publishable_Bb9aLd7CVEX7OwYcO7k2sA_Q47be6vq';

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);
